var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDropdown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8966_829422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0514474 2.64684C0.0514474 2.39554 0.149754 2.15987 0.328794 1.98278C0.506527 1.80764 0.741554 1.71195 0.990901 1.7139C1.24025 1.71584 1.47397 1.81416 1.64845 1.99124L4.00001 4.3721L6.33203 2.01076C6.50717 1.83368 6.74089 1.73472 6.99023 1.73342C7.23958 1.73147 7.47461 1.82716 7.65169 2.0023C7.83073 2.17938 7.92969 2.41506 7.92969 2.66702C7.92969 2.91376 7.83398 3.14683 7.66015 3.32262L4.66406 6.35582C4.47786 6.53942 4.24283 6.63511 3.99349 6.63316C3.74414 6.63122 3.51042 6.5329 3.33594 6.35582L0.320314 3.30308C0.147141 3.1273 0.0514474 2.89424 0.0514474 2.64684Z",
    fill: "#B1B1B1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8966_829422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDropdown);
export default __webpack_public_path__ + "static/media/chevron-dropdown.5b958e47aeb2c72a2396ece1a30240f3.svg";
export { ForwardRef as ReactComponent };